// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"df92a2b9","977":"5cc2826a"}[chunkId] + ".chunk.js";
};